import Swiper from 'swiper';
import { Navigation, EffectCards, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-cards';

import './calculator';
import './post-archive-filter';
import initPostToc from './post-toc';

( function( $ ) {

    $( function() {

        initPostToc();

        // Producten
        const swiperContainers = document.querySelectorAll('.js-fullSwiper');

        swiperContainers.forEach(container => {
            const parentEl = container.closest('.js-sliderWrap');
            const paginationEl = parentEl ? parentEl.querySelector('.swiper-pagination') : null;

            new Swiper(container, {
                modules: [ Pagination ],
                pagination: {
                    clickable: true,
                    enabled: true,
                    el: paginationEl,
                },
                initialSlide: 1,
                slidesPerView: 1,
                autoplay: false,
                centeredSlides: true,
                breakpoints: {
                    768: {
                        slidesPerView: 1,
                        initialSlide: 1,
                        spaceBetween: 0,
                        pagination: {
                            enabled: false
                        }
                    },
                    1024: {
                        slidesPerView: 3,
                        initialSlide: 2,
                        spaceBetween: 40,
                        pagination: {
                            enabled: false
                        }
                    },
                    1680: {
                        slidesPerView: 5,
                        initialSlide: 2,
                        spaceBetween: 80,
                        pagination: {
                            enabled: false
                        }
                    }
                }
            });
        });

        // Producten
        const swiperReviews = document.querySelectorAll('.js-reviewSwiper');

        swiperReviews.forEach(container => {
            const parentEl = container.closest('.js-sliderWrap');
            const paginationEl = parentEl ? parentEl.querySelector('.swiper-pagination') : null;

            new Swiper(container, {
                modules: [ Pagination ],
                pagination: {
                    clickable: true,
                    enabled: true,
                    el: paginationEl,
                },
                initialSlide: 1,
                slidesPerView: 1,
                autoplay: true,
                centeredSlides: true,
                spaceBetween: 30,
                breakpoints: {
                    720: {
                        slidesPerView: 2,
                        initialSlide: 1,
                        pagination: {
                            enabled: false
                        }
                    },
                    1024: {
                        slidesPerView: 3,
                        initialSlide: 2,
                        pagination: {
                            enabled: false
                        }
                    },
                    1780: {
                        slidesPerView: 5,
                        initialSlide: 2,
                        pagination: {
                            enabled: false
                        }
                    }
                }
            });
        });

        if ( ! document.body.classList.contains( 'single-product' ) ) {
            const voordelenSwiper = new Swiper( '.js-voordelenSlider', {
                modules: [ Pagination ],
                pagination: {
                    clickable: true,
                    el: '.voordelen-swiper-pagination',
                },
                slidesPerView: 1,
                autoplay: true
            });
        }

        const headerCtaSwipers = document.querySelectorAll( '.js-headerCtaBarSwiper' );

        headerCtaSwipers.forEach( container => {
            new Swiper( container, {
                modules: [ Autoplay ],
                slidesPerView: 1,
                loop: true,
                allowTouchMove: false,
                speed: 500,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                }
            } );
        } );

        const imageSwiper = new Swiper( '.js-ImageSlider', {
            modules: [ Navigation ],
            initialSlide: 1,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                480: {
                    spaceBetween: 30
                },
                1280: {
                    spaceBetween: 50
                }
            }
        } );

        var swiperCards = new Swiper( '.js-cardsSlider', {
            modules: [ EffectCards, Autoplay, Navigation ],
            effect: "cards",
            autoplay: false,
            initialSlide: 1,
            slidesPerView: 1,
            grabCursor: true,
            speed: 500,
            loop: false,
            navigation: {
                nextEl: '.js-cardsSliderNext',
                prevEl: '.js-cardsSliderPrev',
            },
            mousewheel: {
                invert: false,
            },
            cardsEffect: {
                perSlideOffset: 30,
                perSlideRotate: 10,
                rotate: true,
                slideShadows: false
            }
        } );

        /*
        swiperCards.on( 'activeIndexChange', function ( swiper ) {
            
            const colorClass = swiper.slides[swiper.activeIndex].getAttribute( 'data-set-color' );
            const bgClass = swiper.slides[swiper.activeIndex].getAttribute( 'data-set-bg' );
            const bgDarkClass = swiper.slides[swiper.activeIndex].getAttribute( 'data-set-bgdark' );

            $( '.js-headerHomeTitle' ).attr( 'data-color', colorClass );
            $( '.js-headerHome' ).attr( 'data-bg', bgClass );
            $( '.js-headerBtn' ).attr( 'data-bg-path', bgDarkClass );
            $( '.js-openLocationModal' ).attr( 'data-bg-path', bgDarkClass );
            $( '.js-openCalculatorModal' ).attr( 'data-bg-path', bgDarkClass );
            $( '.js-waveSvg' ).attr( 'data-bg-path', bgDarkClass );
            $( '.js-homeStory' ).attr( 'data-bg', bgDarkClass );
            $( '.js-bar' ).attr( 'data-bg', bgDarkClass );
            $( '.js-openMenu' ).attr( 'data-bg', bgClass );

        });
        */

        
        const mobileMenuElement = document.querySelector( '.js-mobileMenuMenu' );
        const mobileMenuPanels = mobileMenuElement ? Array.from( mobileMenuElement.querySelectorAll( '.o-mobileMenu__panel' ) ) : [];

        const setMobileMenuHeight = panel => {
            if ( ! mobileMenuElement || ! panel ) {
                return;
            }

            const panelsWrap = mobileMenuElement.querySelector( '.js-mobileMenuPanels' );

            if ( panelsWrap ) {
                panelsWrap.style.height = `${panel.offsetHeight}px`;
            }
        };

        const setActiveMobileMenuPanel = panelId => {
            if ( ! mobileMenuElement || ! mobileMenuPanels.length ) {
                return;
            }

            const nextPanel = mobileMenuElement.querySelector( `[data-panel-id="${panelId}"]` );

            if ( ! nextPanel ) {
                return;
            }

            const visiblePanelIds = new Set();
            let currentPanel = nextPanel;

            while ( currentPanel ) {
                visiblePanelIds.add( currentPanel.dataset.panelId );

                const parentPanelId = currentPanel.dataset.parentPanel;
                currentPanel = parentPanelId ? mobileMenuElement.querySelector( `[data-panel-id="${parentPanelId}"]` ) : null;
            }

            mobileMenuPanels.forEach( panel => {
                panel.classList.remove( 'is-active', 'is-before' );

                if ( panel.dataset.panelId === panelId ) {
                    panel.classList.add( 'is-active' );
                } else if ( visiblePanelIds.has( panel.dataset.panelId ) ) {
                    panel.classList.add( 'is-before' );
                }
            } );

            setMobileMenuHeight( nextPanel );
        };

        const resetMobileMenuPanels = () => {
            setActiveMobileMenuPanel( 'mobile-panel-root' );
        };

        if ( mobileMenuElement && mobileMenuPanels.length ) {
            resetMobileMenuPanels();

            mobileMenuElement.querySelectorAll( '.js-mobileMenuOpen, .js-mobileMenuBack' ).forEach( button => {
                button.addEventListener( 'click', () => {
                    setActiveMobileMenuPanel( button.dataset.targetPanel );
                } );
            } );

            window.addEventListener( 'resize', () => {
                const activePanel = mobileMenuElement.querySelector( '.o-mobileMenu__panel.is-active' );

                if ( activePanel ) {
                    setMobileMenuHeight( activePanel );
                }
            } );
        }

        $( '.js-openMenu' ).on( 'click', function() {

            if ( ! $( 'body' ).hasClass( '-openMenu' ) ) {

                document.documentElement.style.setProperty( '--scroll-top', window.scrollY );

                $( 'body' ).addClass( '-openMenu' );

                setActiveMobileMenuPanel( 'mobile-panel-root' );

                requestAnimationFrame( () => {
                    const activePanel = mobileMenuElement ? mobileMenuElement.querySelector( '.o-mobileMenu__panel.is-active' ) : null;

                    if ( activePanel ) {
                        setMobileMenuHeight( activePanel );
                    }
                } );

                setTimeout(() => {
                    $('body').addClass('-overflow');
                }, 300);

            } else {

                const scrollY = Math.abs(parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--scroll-top' ) ) );

                $( 'body' ).removeClass( '-openMenu -overflow' );

                resetMobileMenuPanels();

                window.scrollTo( 0, scrollY );

            }
            
        } );

        // Helper functions
        function formatPhoneNumber(phone) {
            return `tel:${phone.replace(/[^\d+]/g, '')}`;
        }

        function cleanUrl(url) {
            return url.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '');
        }

        function ensureHttp(url) {
            if (!/^https?:\/\//i.test(url)) {
                return `https://${url}`;
            }

            return url;
        }

        function getDirectionsUrl(entry) {
            if ( entry.coords && entry.coords.lat && entry.coords.lng ) {
                return `https://www.google.com/maps/dir/?api=1&destination=${entry.coords.lat},${entry.coords.lng}`;
            }

            return '';
        }

        // Handle form submission
        const $modal_form = $('#modalPostalCodeForm');
        const $modal_location_error = $('#modalLocationError');
        const $modal_form_result = $('#modalPostalCodeResult');
        
        $modal_form.on('submit', function (e) {

            e.preventDefault();

            $modal_location_error.hide();

            if ($modal_form.hasClass('-busy')) {
                return;
            }

            $modal_form.addClass('-busy');

            const postalCode = $('#modal-postcode').val();

            if (postalCode == '') {
                return;
            }            

            // Perform AJAX request
            const req = $.ajax({
                url: window.postalCodeAjax.ajaxUrl,
                method: 'POST',
                data: {
                    action: 'lookup_postal_code_product',
                    postal_code: postalCode,
                },
                success: function (response) {

                    if (response.success) {

                        const entry = response.data;
                        const directionsUrl = getDirectionsUrl( entry );
                        const websiteUrl = entry.website ? ensureHttp( entry.website ) : '';
                        const websiteLabel = entry.website_label || ( entry.website ? cleanUrl( entry.website ) : '' );

                        $modal_form_result.html(`
                            <div class="m-modalLocationItem">
                                <h4>
                                    ${entry.name || ''}
                                </h4>
                                <div class="m-modalLocationItem__top u-fs22">
                                    <div class="m-modalLocationItem__address">
                                        ${entry.address || ''}
                                    </div>
                                    <div class="m-modalLocationItem__contact">
                                        ${entry.phone ? 
                                            `<a href="${formatPhoneNumber(entry.phone)}" class="u-cBlack u-fw600">${entry.phone}</a>` 
                                            : ''
                                        }
                                        ${entry.website ? 
                                            `<a target="_blank" rel="noopener" href="${websiteUrl}" class="u-cBlack u-fw600">${websiteLabel}</a>` 
                                            : ''
                                        }
                                    </div>
                                </div>
                                <div class="m-modalLocationItem__actions">
                                    ${directionsUrl ? 
                                        `<a class="a-button" target="_blank" rel="noopener" href="${directionsUrl}">${window.postalCodeAjax.route}</a>`
                                        : ''
                                    }
                                    ${entry.phone ? 
                                        `<a class="a-button" href="${formatPhoneNumber(entry.phone)}">${window.postalCodeAjax.call}</a>`
                                        : ''
                                    }
                                    ${entry.website ? 
                                        `<a class="a-button" target="_blank" rel="noopener" href="${websiteUrl}">${window.postalCodeAjax.websiteLabel}</a>`
                                        : ''
                                    }
                                </div>
                            </div>
                        `);

                    } else {

                        $modal_location_error.show();

                    }
                },
                error: function (error) {

                    $modal_location_error.show();

                },
            });

            req.done(function () {
                $modal_form.removeClass('-busy');
            });
        });

        $( '.js-openLocationModal' ).on( 'click', function( e ) {

            e.preventDefault();

            $( '.js-locationModal' ).addClass( '-active' );

            $( '.js-modalOverlay' ).addClass( '-active' );

        } );

        $( '.js-openCalculatorModal' ).on( 'click', function( e ) {

            e.preventDefault();

            $( '.js-calculatorModal' ).addClass( '-active' );

            $( '.js-modalOverlay' ).addClass( '-active' );

        } );

        const closeModals = () => {
            $( '.js-calculatorModal' ).removeClass( '-active' );
            $( '.js-locationModal' ).removeClass( '-active' );
            $( '.js-modalOverlay' ).removeClass( '-active' );
        };

        $( '.js-closeModal' ).on( 'click', function() {

            closeModals();

        } );

        $( '.o-modal' ).on( 'click', function( e ) {

            if ( ! $( e.target ).closest( '.o-modal__inner' ).length ) {
                closeModals();
            }

        } );
        
        $( '.js-modalOverlay' ).on( 'click', function() {

            closeModals();

        } );

    } );

} ) ( jQuery );

document.addEventListener( "DOMContentLoaded", () => {
    const sampleRequest = document.querySelector( '.js-sampleRequest' );

    if ( sampleRequest ) {
        const productSelect = sampleRequest.querySelector( '.js-sampleRequestProduct' );
        const intro = sampleRequest.querySelector( '.js-sampleRequestIntro' );
        const image = sampleRequest.querySelector( '.js-sampleRequestImage' );
        const formWrap = sampleRequest.querySelector( '.js-sampleRequestForm' );
        const header = sampleRequest.querySelector( '.o-sampleRequestPage' );
        const formCard = sampleRequest.querySelector( '.o-sampleRequest__formCard' );
        const externalColorTargets = Array.from( document.querySelectorAll( '.js-headerCtaBar[data-color-target]' ) );
        const colorTargets = [
            ...( sampleRequest.matches( '[data-color-target]' ) ? [ sampleRequest ] : [] ),
            ...Array.from( sampleRequest.querySelectorAll( '[data-color-target]' ) ),
            ...externalColorTargets
        ];
        const landscapes = Array.from( sampleRequest.querySelectorAll( '.js-sampleRequestLandscape' ) );
        const colorOptions = productSelect ? Array.from( productSelect.options ).map( option => option.dataset.pcColor ).filter( Boolean ) : [];
        let previousProductTitle = formWrap ? formWrap.dataset.product : '';
        let previousProductSlug = formWrap ? formWrap.dataset.productSlug : '';

        const updateHeaderOverflow = () => {
            if ( ! header || ! formCard ) {
                return;
            }

            const formStyles = window.getComputedStyle( formCard );

            if ( 'absolute' !== formStyles.position ) {
                const mobileFormOverlap = formCard.getBoundingClientRect().height * 0.75;

                header.style.setProperty( '--sample-request-form-overflow', `${mobileFormOverlap}px` );
                return;
            }

            const headerRect = header.getBoundingClientRect();
            const formRect = formCard.getBoundingClientRect();
            const overflow = Math.max( 0, formRect.bottom - headerRect.bottom );

            header.style.setProperty( '--sample-request-form-overflow', `${overflow}px` );
        };

        const syncFormProduct = ( title, slug ) => {
            if ( ! formWrap ) {
                return;
            }

            formWrap.dataset.product = title;
            formWrap.dataset.productSlug = slug;

            const form = formWrap.querySelector( 'form' );

            if ( ! form ) {
                previousProductTitle = title;
                previousProductSlug = slug;
                return;
            }

            let productInput = form.querySelector( 'input[name="cavom_sample_product"]' );

            if ( ! productInput ) {
                productInput = document.createElement( 'input' );
                productInput.type = 'hidden';
                productInput.name = 'cavom_sample_product';
                form.appendChild( productInput );
            }

            productInput.value = title;

            let slugInput = form.querySelector( 'input[name="cavom_sample_product_slug"]' );

            if ( ! slugInput ) {
                slugInput = document.createElement( 'input' );
                slugInput.type = 'hidden';
                slugInput.name = 'cavom_sample_product_slug';
                form.appendChild( slugInput );
            }

            slugInput.value = slug;

            form.querySelectorAll( 'input[type="hidden"]' ).forEach( input => {
                if ( input === productInput || input === slugInput ) {
                    return;
                }

                if ( input.value === previousProductTitle ) {
                    input.value = title;
                }

                if ( input.value === previousProductSlug ) {
                    input.value = slug;
                }
            } );

            previousProductTitle = title;
            previousProductSlug = slug;
        };

        const updateColorClasses = pcColor => {
            colorTargets.forEach( target => {
                const prefix = target.dataset.colorPrefix;

                if ( ! prefix ) {
                    return;
                }

                colorOptions.forEach( color => {
                    if ( 'data-bg' === target.dataset.colorMode ) {
                        if ( target.dataset.bg === `${prefix}${color}` ) {
                            target.dataset.bg = '';
                        }

                        return;
                    }

                    target.classList.remove( `${prefix}${color}` );
                } );

                if ( 'data-bg' === target.dataset.colorMode ) {
                    target.dataset.bg = `${prefix}${pcColor}`;
                } else {
                    target.classList.add( `${prefix}${pcColor}` );
                }

                target.dataset.currentColor = pcColor;
            } );
        };

        const updateProduct = ( option, updateUrl = true ) => {
            if ( ! option ) {
                return;
            }

            const title = option.dataset.title || option.textContent.trim();
            const slug = option.value;
            const pcColor = option.dataset.pcColor || 'Green';

            if ( intro ) {
                intro.textContent = option.dataset.intro || '';
            }

            if ( image && option.dataset.image ) {
                image.src = option.dataset.image;
                image.alt = title;
                image.title = title;
            }

            landscapes.forEach( landscape => {
                landscape.classList.toggle( '-active', landscape.dataset.product === slug );
            } );

            updateColorClasses( pcColor );
            syncFormProduct( title, slug );
            updateHeaderOverflow();

            if ( updateUrl ) {
                const url = new URL( window.location.href );
                url.searchParams.set( 'sample_product', slug );
                window.history.replaceState( {}, '', url );
            }
        };

        if ( productSelect ) {
            productSelect.addEventListener( 'change', () => {
                updateProduct( productSelect.selectedOptions[0] );
            } );

            updateProduct( productSelect.selectedOptions[0], false );
        }

        if ( image ) {
            image.addEventListener( 'load', updateHeaderOverflow );
        }

        if ( 'ResizeObserver' in window && formCard ) {
            const sampleRequestResizeObserver = new ResizeObserver( updateHeaderOverflow );
            sampleRequestResizeObserver.observe( formCard );

            if ( header ) {
                sampleRequestResizeObserver.observe( header );
            }
        }

        window.addEventListener( 'resize', updateHeaderOverflow );
        updateHeaderOverflow();
    }

    const fixedCtaTrigger = document.querySelector( '.js-singleProductCtaInline' )
        || document.querySelector( '.js-headerHome[data-fixed-cta-after-hero]' );
    const fixedCtaBar = document.querySelector( '.js-fixedCtaBar' );

    if ( fixedCtaBar ) {
        const updateFixedCtaBarMetrics = () => {
            const fixedCtaBarHeight = fixedCtaBar.classList.contains( '-active' ) ? fixedCtaBar.getBoundingClientRect().height : 0;

            document.body.style.setProperty( '--fixed-cta-page-offset', `${ fixedCtaBarHeight }px` );
            document.body.style.setProperty( '--fixed-cta-button-offset', `${ fixedCtaBarHeight }px` );
        };

        if ( 'ResizeObserver' in window ) {
            const fixedCtaResizeObserver = new ResizeObserver( updateFixedCtaBarMetrics );
            fixedCtaResizeObserver.observe( fixedCtaBar );
        }

        window.addEventListener( 'resize', updateFixedCtaBarMetrics );
        updateFixedCtaBarMetrics();

        fixedCtaBar.updateFixedCtaBarMetrics = updateFixedCtaBarMetrics;
    }

    const enableFixedCtaBarTransitions = () => {
        fixedCtaBar.classList.add( '-ready' );
    };

    if ( fixedCtaBar && fixedCtaTrigger ) {
        const observer = new IntersectionObserver( entries => {
            entries.forEach( entry => {
                fixedCtaBar.classList.toggle( '-active', ! entry.isIntersecting );
                fixedCtaBar.updateFixedCtaBarMetrics?.();
            } );
        }, {
            threshold: 0.15
        } );

        observer.observe( fixedCtaTrigger );

        requestAnimationFrame( () => {
            requestAnimationFrame( enableFixedCtaBarTransitions );
        } );
    } else if ( fixedCtaBar ) {
        enableFixedCtaBarTransitions();
    }

    const faqItems = document.querySelectorAll( '.js-faqItem' );

    faqItems.forEach( item => {
        item.addEventListener( 'click', () => {
            item.classList.toggle( '-active' );
        } );
    } );

    const tabItems = document.querySelectorAll( '.js-productTab' );

    tabItems.forEach( item => {
        item.addEventListener( 'click', () => {
            item.classList.toggle( '-active' );
        } );
    } );
    
    const onzeProducten = document.getElementById('onze-producten');

    if (onzeProducten) {
        const checkScrollPosition = () => {
            const rect = onzeProducten.getBoundingClientRect();
            if (rect.top < 0) {
                document.body.classList.add('-removeChange');
            } else {
                document.body.classList.remove('-removeChange');
            }
        };

        window.addEventListener('scroll', checkScrollPosition);
        checkScrollPosition();
    }

} );